/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Invert_LabelInputs */

const en_video_filters_invert_label = /** @type {(inputs: Video_Filters_Invert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invert`)
};

const fr_video_filters_invert_label = /** @type {(inputs: Video_Filters_Invert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverser`)
};

const de_video_filters_invert_label = /** @type {(inputs: Video_Filters_Invert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umkehren`)
};

const it_video_filters_invert_label = /** @type {(inputs: Video_Filters_Invert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invertire`)
};

const ru_video_filters_invert_label = /** @type {(inputs: Video_Filters_Invert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инвертировать`)
};

const es_video_filters_invert_label = /** @type {(inputs: Video_Filters_Invert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invertir`)
};

const zh_cn2_video_filters_invert_label = /** @type {(inputs: Video_Filters_Invert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`倒置`)
};

const ja_video_filters_invert_label = /** @type {(inputs: Video_Filters_Invert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反転`)
};

const hi_video_filters_invert_label = /** @type {(inputs: Video_Filters_Invert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`औंधाना`)
};

const pt_pt2_video_filters_invert_label = /** @type {(inputs: Video_Filters_Invert_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invertido`)
};

/**
* | output |
* | --- |
* | "Invert" |
*
* @param {Video_Filters_Invert_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_invert_label = /** @type {((inputs?: Video_Filters_Invert_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Invert_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_filters_invert_label(inputs)
	if (locale === "de") return de_video_filters_invert_label(inputs)
	if (locale === "it") return it_video_filters_invert_label(inputs)
	if (locale === "ru") return ru_video_filters_invert_label(inputs)
	if (locale === "es") return es_video_filters_invert_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_filters_invert_label(inputs)
	if (locale === "ja") return ja_video_filters_invert_label(inputs)
	if (locale === "hi") return hi_video_filters_invert_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_filters_invert_label(inputs)
	return en_video_filters_invert_label(inputs)
});